import React, { Suspense, lazy } from 'react';
import AdminControlledLoadingScreen from '../components/AdminControlledLoadingScreen';

// This renders before the provider tree, so read the cached theme directly.
const Theme2LoadingScreen = lazy(() => import('./theme2/Theme2LoadingScreen'));

const readTheme = () => {
  try {
    return (
      localStorage.getItem('niswa_theme_preview') ||
      localStorage.getItem('niswa_active_theme') ||
      'theme1'
    );
  } catch (e) {
    return 'theme1';
  }
};

const ThemedLoadingScreen = (props) => {
  if (readTheme() === 'theme2') {
    return (
      <Suspense fallback={null}>
        <Theme2LoadingScreen {...props} />
      </Suspense>
    );
  }
  return <AdminControlledLoadingScreen {...props} />;
};

export default ThemedLoadingScreen;
